import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ImageGallery from "../components/ImageGallery";
import Footer from '../components/footer';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useSanityQuery } from '../../hooks/useSanityQuery';
import { urlFor } from '../../lib/imageUrlFor';

const PROJECTS_QUERY = `*[_type == "project" && isActive == true] | order(order asc) {
  title,
  "slug": slug.current,
  galleryThumbnail,
  galleryCaption,
  galleryDescription
}`;

const Projects = () => {
  const elementsRef = useRef([]);
  const { data: projects } = useSanityQuery(PROJECTS_QUERY);

  useEffect(() => {
    const elements = elementsRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((element) => {
      if (element) {
        element.classList.add('hidden');
        observer.observe(element);
      }
    });

    return () => {
      elements.forEach((element) => {
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, []);

  const sanityImages = projects
    ? projects.map((project) => ({
        src: project.galleryThumbnail
          ? urlFor(project.galleryThumbnail).width(500).height(500).url()
          : '/img/gallery/0.jpg',
        alt: project.title,
        caption: project.galleryCaption || project.title,
        description: project.galleryDescription || '',
        width: 500,
        height: 500,
        slug: project.slug,
      }))
    : null;

  return (
    <div>
      <section className='jumbotron breadcumb' style={{backgroundImage: `url(${'/img/projects.jpg'})`}} ref={(el) => (elementsRef.current[0] = el)}>
        <div className='mainbreadcumb'>
          <div className='container-fluid'>
            <div className='row m-10-hor'>
              <div className='col-md-6'>
                <h1>Projects</h1>
              </div>
              <div className='col-md-6'>
                <div className='list'>
                  <Link className='link' to="/">Home</Link>
                  <span className='dash'>/</span>
                  <span>Projects</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container-fluid black' ref={(el) => (elementsRef.current[1] = el)}>
        <div className='row m-10-hor'>
          <div className='col-md-5'>
            <div className='heading'>
              Projects that<span className='br'></span> Serve Humanity
            </div>
          </div>
          <div className='col-md-7'>
            <div className='content'>
              Our Projects section highlights the heart and soul of our humanitarian efforts. We are committed to improving the lives of the underprivileged, one project at a time. From organizing extensive food drives and building sustainable housing to providing clean water access in remote areas, each initiative represents our unwavering commitment to making a difference. Scroll through to see how we are turning compassion into action, and how you can contribute to these life-changing endeavors.
            </div>
          </div>
        </div>
      </section>

      <section className='container-fluid black_more' ref={(el) => (elementsRef.current[2] = el)}>
        <div className='row m-10-hor'>
          <div className='col-12'>
            <div className='AppContainer'>
              <ImageGallery images={sanityImages} />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Projects;
